import React, { useEffect, useState, useRef } from 'react';
import Button from '../ui/Button';

// Sidebar component for editing slides with customizable title and actions
function Sidebar({ open, setOpen, title = 'Edit Slide', rightCTA, children, onConfirm, isLoading, isDisabled=false }) {
  const [visible, setVisible] = useState(false);
  const sidebarRef = useRef(null);

  // Handle sidebar visibility and focus management
  useEffect(() => {
    if (open) {
      setVisible(true);
      if (sidebarRef.current) {
        sidebarRef.current.focus();
      }
    } else {
      const timeout = setTimeout(() => setVisible(false), 300);
      return () => clearTimeout(timeout);
    }
  }, [open]);

  if (!visible) return null;

  return (
    <div
      className={`fixed inset-0 flex justify-end z-50 bg-gray-800 bg-opacity-50 transition-opacity duration-300 ${
        open ? 'opacity-100' : 'opacity-0'
      }`}
      onClick={(e) => {
        // Close sidebar when clicking overlay
        if (e.target === e.currentTarget) {
          setOpen(false);
        }
      }}
    >
      <div
        ref={sidebarRef}
        tabIndex={0}
        className={`w-1/4 h-full bg-white flex flex-col shadow-lg transform transition-transform duration-300 ${
          open ? 'translate-x-0' : 'translate-x-full'
        }`}
        onKeyDown={(e) => {
          // Close sidebar on Escape key
          if (e.key === 'Escape') {
            setOpen(false);
          }
        }}
      >
        <div className="p-4 bg-gray-100 text-lg font-semibold border-b">
          {title}
        </div>
        <div className="flex-1 overflow-y-auto p-4">
          {children}
        </div>
        <div className="p-4 border-t bg-gray-100 flex justify-between space-x-4">
          <button
            className="text-blue-600"
            onClick={() => setOpen(false)}
          >
            Cancel
          </button>
          <Button onClick={onConfirm} disabled={isLoading || isDisabled}>
            {rightCTA || "Insert"}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;